<template>
	<popup-view class="context-popup-view" v-bind="$attrs" @close="$emit('close')">
		<div v-if="results">
			<plethora-tabs-view style="margin: 0 30px 0 20px;" class="tabs" :value="tab" @input="changeTab" :tabs="[
				{
					label: 'Kunder',
					value: 'customers',
					badge: {
						visible: true,
						label: results.customers.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				},
				{
					label: 'Henvendelser',
					value: 'leads',
					badge: {
						visible: true,
						label: results.leads.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				},
				{
					label: 'Tilbud',
					value: 'quotes',
					badge: {
						visible: true,
						label: results.quotes.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				},
				{
					label: 'Ordrer',
					value: 'orders',
					badge: {
						visible: true,
						label: results.orders.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				},
				{
					label: 'Opgaver',
					value: 'tasks',
					badge: {
						visible: true,
						label: results.tasks.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				},
				{
					label: 'Fakturaer',
					value: 'invoices',
					badge: {
						visible: true,
						label: results.invoices.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				},
				{
					label: 'Leverandører',
					value: 'suppliers',
					badge: {
						visible: true,
						label: results.suppliers.length,
						style: {
							background: {
								color: '#F0F0F0'
							},
							font: {
								color: '#7F7F7F'
							}
						}
					}
				}
			]" />
			<div class="search-page" v-show="tab == 'customers'">
				<div v-show="results.customers.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.customers.length > 0" class="list">
					<div @click="customerClick('open', item)" class="item" v-for="(item, i) in results.customers" :key="i" @mouseenter="$store.commit('hover', [item, 'left', 'contact'])" @mouseleave="$store.commit('hover', [null, 'left', null])">
						<div class="info">
							#{{ item.num | integer }}, {{ item.name }}, {{ item.address }}, {{ item.zip }} {{ item.city }}
						</div>
						<div class="tools">
							<div @click.stop="customerClick('quote', item)">Tilbud</div>
							<div @click.stop="customerClick('order', item)">Ordre</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search-page" v-show="tab == 'leads'">
				<div v-show="results.leads.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.leads.length > 0" class="list">
					<div @click="leadClick('open', item)" class="item" v-for="(item, i) in results.leads" :key="i">
						<div class="info">
							#{{ item.num | integer }}, {{ item.created | date }}, {{ item.name }}, {{ item.phone }}, {{ item.email }}
						</div>
						<div class="tools">
							<div @click.stop="leadClick('survey', item)">Besigtigelse</div>
							<div @click.stop="leadClick('quote', item)">Tilbud</div>
							<div @click.stop="leadClick('order', item)">Ordre</div>
							<div @click.stop="leadClick('delete', item)">Slet</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search-page" v-show="tab == 'quotes'">
				<div v-show="results.quotes.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.quotes.length > 0" class="list">
					<div @click="quoteClick('open', item)" class="item" v-for="(item, i) in results.quotes" :key="i">
						<div class="info">
							#{{ item.num | integer }}, {{ item.created | date }}, {{ item.customer.name }}, {{ item.customer.address.address }}, {{ item.customer.address.zip }} {{ item.customer.address.city }}
						</div>
						<div class="tools">
							<div @click.stop="quoteClick('copy', item)">Kopi</div>
							<div @click.stop="quoteClick('order', item)">Ordre</div>
							<div @click.stop="quoteClick('print', item)">Udskriv</div>
							<div @click.stop="quoteClick('delete', item)">Slet</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search-page" v-show="tab == 'orders'">
				<div v-show="results.orders.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.orders.length > 0" class="list">
					<div @click="orderClick('open', item)" class="item" v-for="(item, i) in results.orders" :key="i">
						<div class="info">
							#{{ item.num | integer }}, {{ item.created | date }}, {{ item.customer.name }}, {{ item.customer.address.address }}, {{ item.customer.address.zip }} {{ item.customer.address.city }}
						</div>
						<div class="tools">
							<div @click.stop="orderClick('archive', item)">Arkiver</div>
							<div @click.stop="orderClick('copy', item)">Kopi</div>
							<div @click.stop="orderClick('print', item)">Udskriv</div>
							<div @click.stop="orderClick('delete', item)">Slet</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search-page" v-show="tab == 'tasks'">
				<div v-show="results.tasks.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.tasks.length > 0" class="list">
					<div @click="taskClick('open', item)" class="item" v-for="(item, i) in results.tasks" :key="i" @mouseenter="$store.commit('hover', [item, 'left', 'task'])" @mouseleave="$store.commit('hover', [null, 'left', null])">
						<div class="info">
							#{{ item.num | integer }}, {{ item.due_start_from | date }}, {{ _types[item.type] ? _types[item.type].label : '-' }}, {{ item.name }}, {{ item.phone }}, {{ item.email }}
						</div>
						<div class="tools">
							<div v-if="item.order_id" @click.stop="taskClick('order', item)">Ordre</div>
							<div @click.stop="taskClick('print', item)">Udskriv</div>
							<div @click.stop="taskClick('close', item)">Luk</div>
							<div @click.stop="taskClick('claim', item)">Skadesag</div>
							<div @click.stop="taskClick('archive', item)">Arkiver ordre</div>
							<div @click.stop="taskClick('delete', item)">Slet</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search-page" v-show="tab == 'invoices'">
				<div v-show="results.invoices.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.invoices.length > 0" class="list">
					<div @click="invoiceClick('open', item)" class="item" v-for="(item, i) in results.invoices" :key="i">
						<div class="info">
							{{ !item.num || item.num == '' ? 'KLADDE' : '#' + (item.num | integer) }}, {{ item.created | date }}, {{ item.customer.name }}, {{ item.customer.phone }}, {{ item.customer.email }}
						</div>
						<div class="tools">
							<div @click.stop="invoiceClick('print', item)">Udskriv</div>
							<div @click.stop="invoiceClick('email', item)">Send e-mail</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search-page" v-show="tab == 'suppliers'">
				<div v-show="results.suppliers.length == 0" class="no-results">Ingen resultater</div>
				<div v-show="results.suppliers.length > 0" class="list">
					<div @click="customerClick('open', item)" class="item" v-for="(item, i) in results.suppliers" :key="i">
						<div class="info">
							{{ item.num | integer }}, {{ item.name }}, {{ item.address }}, {{ item.zip }} {{ item.city }}
						</div>
						<div class="tools">
						</div>
					</div>
				</div>
			</div>
			<div class="pages">
				<div class="prev" @click="goto(Math.max(1, page - 1))">Tilbage</div>
				<div class="current">{{ page }}</div>
				<div class="next" @click="goto(page + 1)">Frem</div>
			</div>
		</div>
		<div v-else style="padding: 30px;">
			<spinner-view />
		</div>
	</popup-view>
</template>

<script>
	import merge from '../functions/merge'


	import ContactModel from '../model/Contact'
	import ContactWindow from '../windows/ContactWindow'

	import LeadModel from '../model/Lead'
	import LeadWindow from '../windows/LeadWindow'

	import QuoteModel from '../model/Quote'
	import QuoteWindow from '../windows/QuoteWindow'

	import OrderModel from '../model/Order'
	import OrderWindow from '../windows/OrderWindow'

	import SurveyTaskModel from '../model/SurveyTask'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'

	import NewInvoiceWindow from '../windows/NewInvoiceWindow';
	import InvoiceModel from '../model/Invoice'

	import MoveTaskModel from '../model/MoveTask'

	import TaskController from '../../components/TaskController'

	import { bus } from '../../bus';

	export default {
		data() {
			return {
				tab: 'customers',
				types: [],
				results: null
			};
		},
		props: {
			gotoTab: {
				type: String,
				default: null
			},
			page: {
				type: Number,
				default: 1
			},
			request: {
				type: Array,
				default: function () {
					return [];
				}
			},
			select: {
				type: Function,
				default: function () {}
			}
		},
		computed: {
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				

				return r;
			}
		},
		methods: {
			changeTab(tab) {
				console.log('change tab', tab);
				this.tab = tab;
				this.$emit('changeTab', tab);
			},
			update() {
				bus.$emit('update');
			},
			async customerClick(action, item) {
				this.$store.commit('hover', [null, 'left', null]);
				this.$emit('close');
				
				var self = this;
				var ent;

				if (action == 'open') {
					ent = await ContactModel.read(self.axios, item.id);

					self.$store.state.windowStack.push(ContactWindow, {
						value: ent, 
						submit: async function (entity) {
							if (await ContactModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'quote') {
					ent 					= QuoteModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
					ent.contact_id 			= item.id;
					ent._embedded.contact	= item;

					self.$store.state.windowStack.push(QuoteWindow, {
						value: ent,
						lookup: true,
						async submit(entity) {
							if (await QuoteModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'order') {
					ent 					= OrderModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
					ent.contact_id 			= item.id;
					ent._embedded.contact	= item;

					self.$store.state.windowStack.push(OrderWindow, {
						value: ent,
						lookup: true,
						async submit(entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}
			},
			async autoCustomer(ent, item) {
				var contact = null;

				

				if (item.contact_id === null) {
					if (confirm('Vil du oprette en kontakt til formålet?')) {
						var c = ContactModel.entity();
						c.name 		= item.name;
						c.email 	= item.email;
						c.phone 	= item.phone;
						c.address	= item.details.address.address;
						c.zip		= item.details.address.zip;
						c.city		= item.details.address.city;
						c.country	= item.details.address.country;
						c.roles		= {};

						if (item.details.type == 'private') {
							c.roles['private'] = { enabled: true };
						}

						if (item.details.type == 'business') {
							c.roles['business'] = { enabled: true };
						}

						contact = await ContactModel.save(this.axios, c);

						// Update lead
						var lead 				= await LeadModel.read(this.axios, item.id);
						lead.contact_id 		= contact.id;

						LeadModel.save(this.axios, lead);					
					}
				} else {
					contact = await ContactModel.read(this.axios, item.contact_id);
				}

				if (contact !== null) {
					ent.contact_id 			= contact.id;
					ent._embedded.contact	= contact;
				}

				return ent;
			},
			async leadClick(action, item) {
				this.$store.commit('hover', [null, 'left', null]);
				this.$emit('close');
				
				var self = this;
				var ent;
				var task;

				if (action == 'open') {
					ent = await LeadModel.read(self.axios, item.id);

					self.$store.state.windowStack.push(LeadWindow, {
						value: ent, 
						submit: async function (entity) {
							if (await LeadModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'survey') {
					// Auto create customer?
					ent 					= SurveyTaskModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;

					ent.name				= item.name;
					ent.phone				= item.phone;
					ent.email				= item.email;

					ent.details.area		= item.details.area;
					ent.details.date		= item.details.date;
					ent.remarks				= item.comments;

					ent.details.address		= item.details.address;
					ent.details.dest		= item.details.dest;

					ent.contact_id			= item.contact_id;
					ent._embedded.contact	= item._embedded.contact;

					ent.lead_id 			= item.id; 


					

					ent = await self.autoCustomer(ent, item);

					self.$store.state.windowStack.push(SurveyTaskWindow, {
						value: ent,
						async submit(entity) {
							if (await SurveyTaskModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								//self.update();
								bus.$emit('update');
							}
						}
					});
				}

				if (action == 'quote') {
					/*ent 					= QuoteModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;

					ent.customer.name		= item.name;
					ent.customer.phone		= item.phone;
					ent.customer.email		= item.email;

					ent.contact_id			= item.contact_id;
					ent._embedded.contact	= item._embedded.contact;

					ent.lead_id 			= item.id; 

					ent = await self.autoCustomer(ent, item);

					self.$store.state.windowStack.push(QuoteWindow, {
						value: ent,
						async submit(entity) {
							if (await QuoteModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});*/

			
					ent 					= QuoteModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;

					ent.customer.name		= item.name;
					ent.customer.phone		= item.phone;
					ent.customer.email		= item.email;

					ent.contact_id			= item.contact_id;
					ent._embedded.contact	= item._embedded.contact;

					ent.lead_id 			= item.id; 

					ent.remarks				= item.comments;

					ent = await self.autoCustomer(ent, item);

					// Add moving task
					task 					= MoveTaskModel.entity();
					task.employee_id 		= self.$store.state.employee.id;
					task.department_id 		= self.$store.state.employee.department_id;
					task._embedded.employee	= self.$store.state.employee;

					task.name				= item.name;
					task.phone				= item.phone;
					task.email				= item.email;

					task.contact_id			= ent.contact_id;
					task._embedded.contact	= ent._embedded.contact;

					task.details.route		= [
						{
							address:		item.details.address.address,
							zip:			item.details.address.zip,
							city:			item.details.address.city,
							country:		item.details.address.country,
							instructions:	{},
							elevator:		false,
							distance:		''
						},
						{
							address:		item.details.dest.address,
							zip:			item.details.dest.zip,
							city:			item.details.dest.city,
							country:		item.details.dest.country,
							instructions:	{},
							elevator:		false,
							distance:		''
						}
					];

					task.details.area		= item.details.area;

					ent._embedded.tasks		= [task];


					

					self.$store.state.windowStack.push(QuoteWindow, {
						value: ent,
						lookup: true,
						async submit(entity) {
							if (await QuoteModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								//self.update();
								bus.$emit('update');
							}
						}
					});
				}

				if (action == 'order') {
					/*ent 					= OrderModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;

					ent.customer.name		= item.name;
					ent.customer.phone		= item.phone;
					ent.customer.email		= item.email;

					ent.contact_id			= item.contact_id;
					ent._embedded.contact	= item._embedded.contact;

					ent.lead_id 			= item.id; 

					ent = await self.autoCustomer(ent, item);

					self.$store.state.windowStack.push(OrderWindow, {
						value: ent,
						async submit(entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});*/

			
					ent 					= OrderModel.entity();
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;

					ent.customer.name		= item.name;
					ent.customer.phone		= item.phone;
					ent.customer.email		= item.email;

					ent.contact_id			= item.contact_id;
					ent._embedded.contact	= item._embedded.contact;

					ent.lead_id 			= item.id; 

					ent.remarks				= item.comments;

					ent = await self.autoCustomer(ent, item);

					// Add moving task
					task 					= MoveTaskModel.entity();
					task.employee_id 		= self.$store.state.employee.id;
					task.department_id 		= self.$store.state.employee.department_id;
					task._embedded.employee	= self.$store.state.employee;

					task.name				= item.name;
					task.phone				= item.phone;
					task.email				= item.email;

					task.contact_id			= ent.contact_id;
					task._embedded.contact	= ent._embedded.contact;

					task.details.route		= [
						{
							address:		item.details.address.address,
							zip:			item.details.address.zip,
							city:			item.details.address.city,
							country:		item.details.address.country,
							instructions:	{},
							elevator:		false,
							distance:		''
						},
						{
							address:		item.details.dest.address,
							zip:			item.details.dest.zip,
							city:			item.details.dest.city,
							country:		item.details.dest.country,
							instructions:	{},
							elevator:		false,
							distance:		''
						}
					];

					task.details.area		= item.details.area;

					ent._embedded.tasks		= [task];


					self.$store.state.windowStack.push(OrderWindow, {
						value: ent,
						lookup: true,
						async submit(entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'delete') {
					self.axios.delete('/sales/leads/' + item.id + '/').then(function () {
						self.update();
					});
				}
			},
			async quoteClick(action, item) {
				this.$store.commit('hover', [null, 'left', null]);
				this.$emit('close');
				
				var self = this;

				if (action == 'open') {
					var ent = await QuoteModel.read(self.axios, item.id);

					self.$store.state.windowStack.push(QuoteWindow, {
						value: ent, 
						submit: async function (entity) {
							if (await QuoteModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'copy') {
					ent			= await QuoteModel.read(self.axios, item.id);
					ent.id 		= null;
					ent.created	= null;

					self.$store.state.windowStack.push(QuoteWindow, {
						value: ent,
						async submit(entity) {
							if (await QuoteModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'order') {
					ent				= await QuoteModel.read(self.axios, item.id);
					ent.id 			= null;
					ent.created		= null;
					ent.quote_id	= item.id;

					

					self.$store.state.windowStack.push(OrderWindow, {
						value: ent,
						async submit(entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'print') {
					window.open(process.env.VUE_APP_API + 'sales/quotes/' + item.id + '/print/?token=' + self.$store.state.auth);
				}

				if (action == 'delete') {
					self.axios.delete('/sales/quotes/' + item.id + '/').then(function () {
						self.update();
					});
				}				
			},
			async orderClick(action, item) {
				this.$store.commit('hover', [null, 'left', null]);
				this.$emit('close');
				
				var self = this;

				if (action == 'open') {
					const id = item.id;

					if (!id) {
						alert('Denne opgave har ingen ordre');
						return;
					}

					

					var order = {};
					
					var ent = id ? await OrderModel.read(self.axios, id) : OrderModel.entity();

					if (!id) {
						ent.employee_id 		= self.$store.state.employee.id;
						ent.department_id 		= self.$store.state.employee.department_id;
						ent._embedded.employee	= self.$store.state.employee;
					}

					this.$store.state.windowStack.push(OrderWindow, {
						value: ent, 
						submit: async function (entity, invoice = false, paid = false) {
							if ((order = await OrderModel.save(self.axios, entity, invoice, paid))) {
								//self.$store.state.windowStack.pop();
								//bus.$emit('update');
							}
						}
					});
				}

				if (action == 'copy') {
					ent			= await OrderModel.read(self.axios, item.id);
					ent.id 		= null;
					ent.created	= null;

					self.$store.state.windowStack.push(OrderWindow, {
						value: ent,
						async submit(entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'print') {
					window.open(process.env.VUE_APP_API + 'sales/orders/' + item.id + '/print/?token=' + self.$store.state.auth);
				}

				if (action == 'delete') {
					self.axios.delete('/sales/orders/' + item.id + '/').then(function () {
						self.update();
					});
				}

				if (action == 'archive') {
					if (!confirm('Er du sikker på at du vil arkivere denne ordre? Den kan ikke nemt hentes frem igen.')) return
					self.axios.put(`/orders/${item.id}/archive`);
				}
			},
			async invoiceClick(action, item) {
				this.$store.commit('hover', [null, 'left', null]);
				this.$emit('close');
				
				var self = this;

				if (action == 'open') {
					const invoice = (await this.axios.get(`/invoices/${item.id}/`)).data;

					self.$store.state.windowStack.push(NewInvoiceWindow, {
						value: {
							entity: invoice
						}, 
						submit: async function (entity, doEmail, doPost) {
							// Save invoice here
							
							const m = await InvoiceModel.save(this.axios, entity, doEmail, doPost);

							// Close window
							self.$store.state.windowStack.pop();

							// Return model
							return m;
						}
					});
				}

				if (action == 'email') {
					if (!confirm('Er du sikker på at du vil sende denne faktura?')) return;
					await self.axios.post(`invoices/${item.id}/email`);
				}

				if (action == 'print') {
					window.open(process.env.VUE_APP_API + 'invoices/' + item.id + '/print/?token=' + self.$store.state.auth);
				}
			},
			async taskClick(action, item) {
				this.$store.commit('hover', [null, 'left', null]);
				this.$emit('close');
				
				var self = this;

				if (action == 'open') {
					TaskController.open(self, item.type, item.id);
					/*var ent = await OrderModel.read(self.axios, item.id);

					self.$store.state.windowStack.push(OrderWindow, {
						value: ent, 
						submit: async function (entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});*/
				}

				if (action == 'order') {
					var ent = await OrderModel.read(self.axios, item.order_id);

					self.$store.state.windowStack.push(OrderWindow, {
						value: ent, 
						submit: async function (entity) {
							if (await OrderModel.save(self.axios, entity)) {
								self.$store.state.windowStack.pop();
								self.update();
							}
						}
					});
				}

				if (action == 'print') {
					window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/print/?token=' + self.$store.state.auth);
				}

				if (action == 'delete') {
					self.axios.delete('/planning/tasks/' + item.id + '/').then(function () {
						self.update();
					});
				}

				if (action == 'claim') {
					if (!confirm('Sikker på at du vil sende en invitation til at oprette skadesag?')) return;
					const email = prompt('E-mail', item.email);

					self.axios.post('/claims/' + item.id + '/invite/', {
						email: email
					}).then(function () {
						alert('Formular sendt til kunden');
					});
				}

				if (action == 'close') {
					self.axios.put('/planning/tasks/' + item.id + '/close/').then(function () {
						self.update();
					});
				}

				if (action == 'archive') {
					if (!confirm('Er du sikker på at du vil arkivere denne ordre? Den kan ikke nemt hentes frem igen.')) return
					self.axios.put(`/orders/${item.order_id}/archive`);
				}
			},
			async goto(page) {
				this.results = null;
				this.$emit('goto', page);
			}
		},
		async created() {
			this.types = (await this.axios.get('/tasks/types/')).data._items;
		},
		async mounted() {
			if (this.gotoTab) this.tab = this.gotoTab;

			console.log('await');

			const r = await Promise.all(this.request);

			this.results = {
				customers: r[0].data,
				invoices: r[1].data,
				leads: r[2].data,
				orders: r[3].data,
				quotes: r[4].data,
				suppliers: r[5].data,
				tasks: r[6].data
			};
		},
	}
</script>

<style lang="scss" scoped>
	.context-popup-view {
		& > div {
			& > .search-page {
				border-top: 1px solid #cecece;

				& > .no-results {
					padding: 20px;
				}

				& > .list {
					height: 350px;
					overflow-y: auto;

					& > .item {
						padding: 15px 20px 15px 20px;
						border-bottom: 1px solid #E9E9E9;
						cursor: pointer;
						display: grid;
						grid-template-columns: 1fr auto;
						grid-column-gap: 30px;
						line-height: 30px;

						&::last-child {
							border-bottom: none;
						}

						&:hover {
							background-color: #F8F6F6;
						}

						& > .tools {
							& > div {
								display: inline-block;
								margin-left: 10px;
								background-color: #f0f0f0;
								color: #7f7f7f;
								border-radius: 15px;
								line-height: 30px;
								padding: 0 20px 0 20px;
								font-size: 14px;
							}
						}
					}
				}
			}

			& > .pages {
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;

				& > .current {
					line-height: 60px;
					text-align: center;
				}

				& > .prev, & > .next {
					cursor: pointer;
					line-height: 60px;
					padding: 0 20px 0 20px;
				}

				& > .prev {

				}

				& > .next {
					text-align: right;
				}
			}
		}
	}
</style>